module.exports = [{"name":"head","imgfile":"head.svg"},{"name":"torso","imgfile":"torso.svg"},{"name":"leg","imgfile":"leg.svg"},{"name":"arm","imgfile":"arm.svg"},{"name":"hand","imgfile":"hand.svg"},{"name":"foot","imgfile":"foot2.svg"},{"name":"stand","imgfile":"stand.svg"},{"name":"pose","imgfile":"pose.svg"}]


//////////////////
// WEBPACK FOOTER
// ./src/library/category.json
// module id = 209
// module chunks = 0